import { FC } from "react";
import { cn } from "../lib/utils";
import { Spinner } from "./Spinner";

export type CenteredSpinnerProps = {
	testId?: string;
	className?: string;
	containerClassName?: string;
	spinnerClassName?: string;
};

export const CenteredSpinner: FC<CenteredSpinnerProps> = ({
	testId,
	className,
	containerClassName,
	spinnerClassName,
}) => {
	return (
		<div
			data-testid={testId || "spinner"}
			className={cn("flex w-full h-full justify-center items-center", className)}
		>
			<Spinner containerClassName={containerClassName} spinnerClassName={spinnerClassName} />
		</div>
	);
};
